module.exports = __webpack_public_path__ + "static/media/hack_6_bg.7c658c02.jpg";